import { useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import type { IHardwareOverviewItem } from '@pages/HardwareOverview/model/hardwareOverviewItem';

import { apiClient } from '@services/apiClient';

export const hardwareOverviewKey = () => ['hardwareOverview'];
export const hardwareOverviewFn = () =>
  apiClient.get(`${APP_API_URL_V2}customer-dashboard-v2/hardware-overview`);

const hardwareOverviewSelect = ({ data }: AxiosResponse<{ data: Array<IHardwareOverviewItem> }>) => {
  const list = data?.data || [];
  const availableEquipmentTypes: { [key: string]: boolean } = {};
  const availableEquipmentTypesList: Array<string> = [];

  if (list.length) {
    list.forEach((facility) => {
      if (facility.gateways.countItems && !availableEquipmentTypes['gateways']) {
        availableEquipmentTypes['gateways'] = true;
        availableEquipmentTypesList.push('gateways');
      }
      if (facility.routers.countItems && !availableEquipmentTypes['routers']) {
        availableEquipmentTypes['routers'] = true;
        availableEquipmentTypesList.push('routers');
      }
      if (facility.motes.countItems && !availableEquipmentTypes['motes']) {
        availableEquipmentTypes['motes'] = true;
        availableEquipmentTypesList.push('motes');
      }
      if (facility.nodes.countItems && !availableEquipmentTypes['nodes']) {
        availableEquipmentTypes['nodes'] = true;
        availableEquipmentTypesList.push('nodes');
      }
      if (facility.installationPoints.countItems && !availableEquipmentTypes['installationPoints']) {
        availableEquipmentTypes['installationPoints'] = true;
        availableEquipmentTypesList.push('installationPoints');
      }
      if (facility.tachometers.countItems && !availableEquipmentTypes['tachometers']) {
        availableEquipmentTypes['tachometers'] = true;
        availableEquipmentTypesList.push('tachometers');
      }
    });
  }

  return { list, availableEquipmentTypesList };
};

export const useHardwareOverviewQuery = () => {
  return useQuery({
    // @ts-ignore TODO: update react-query to v5
    queryKey: hardwareOverviewKey(),
    queryFn: hardwareOverviewFn,
    placeholderData: {
      data: {
        data: {
          list: [],
          availableEquipmentTypesList: [],
        },
      },
    },
    select: hardwareOverviewSelect,
  });
};
